import script from "./AIAssistantFab.vue?vue&type=script&setup=true&lang=ts"
export * from "./AIAssistantFab.vue?vue&type=script&setup=true&lang=ts"

import "./AIAssistantFab.vue?vue&type=style&index=0&id=05ec95d7&lang=css"
import "./AIAssistantFab.vue?vue&type=style&index=1&id=05ec95d7&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05ec95d7"]])

export default __exports__